<template>
	<div class="wh">
		<div class="w hnav username ofh">
			<!-- <img class="logo" @click="$router.push('/userManager/userBaseInfo')" src="../assets/img/prod_favicon.png" alt=""> -->
			<img class="logo" @click="jump" src="../assets/img/prod_favicon.png" alt="">
		</div>
		<el-menu style="overflow-y: auto;" unique-opened default-active="1" class="w sel-menu"
		 active-text-color="#33B3FF" :collapse="isCollapse">
			<el-submenu :index="item.id" v-for="item in menuAccess" :key="item.id">
				<template slot="title">
					<i class="iconfont" v-html="iconfont[item.id]"></i>
					<span class="side-title" slot="title">{{ item.title }}</span>
				</template>
				<router-link v-show="item.child && item.child.length != 0 && url[citem.id]"  v-for="citem in item.child" :key="citem.id" :to="url[citem.id] ? url[citem.id] : ''">
					<el-menu-item :index="url[citem.id]" >{{ citem.title }}</el-menu-item>
				</router-link>
			</el-submenu>
		</el-menu>
	</div>
</template>
<script>
	import configData from "@/assets/configData.js"
	export default {
		components: {},
		props: {},
		data() {
			return {
				menuAccess:[],
				url:(configData.url?configData.url:{}),
				iconfont:{
					"1": "&#xe618;",
					"18": "&#xe608;",
					"19": "&#xe60d;",
					"17": "&#xe60a;",
					"5": "&#xe616;",
					"20": "&#xe60e;",
					"21": "&#xe613;",
					"8": "&#xe61b;",
					"67": "&#xe61c;",
					"200494":"&#xe619;"
				},
				defaultopeneds:[],
				fid:"",
				defaultactive:"",
				isCollapse: true,
			}
		},
		watch: {},
		computed: {},
		methods: {
			setfid(id){
				this.fid = id
				return id
			},
		},
		created() {
			this.defaultactive=this.$route.matched[this.$route.matched.length-1].path;
		},
		mounted() {
			if(localStorage.getItem("access")){
				this.menuAccess = JSON.parse(localStorage.getItem("access")).menu_banner;
			}
		},
		methods:{
			jump(){
				// this.$router.push({name:'/',query: {access_token:localStorage.getItem("access_token")}})
				if (window.location.host == 'shiquaner-admin.zookingsoft.com') {
					window.location.href=`http://shiquaner-admin.zookingsoft.com/#/?access_token=${localStorage.getItem("access_token")}`
				}else{
					window.location.href=`http://dev-web-ndesigner-admin.idatachain.cn/#/?access_token=${localStorage.getItem("access_token")}`
				}
			}
		}
	}
</script>
<style lang="scss">
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}
	#app .sel-menu {
		width: 60px;
		border: 0;
		height: calc(100% - 60px);
		// height: 100vh;
		overflow: hidden !important;
	}
	#app .sel-menu > li {
		width: 60px;
		height: 62px;
		line-height: 62px;
	}
	#app .sel-menu > li .el-submenu__title i {
		position: relative;
		top: -3px;
	}
	#app .sel-menu > li .side-title {
		position: relative;
    right: 0;
    left: -50%;
		z-index: 9;
		width: 60px;
    height: 60px;
    transform: translateX(-50%);
    text-align: center;
	}
	.username {
		color: white;
	}
	.username .logo {
		display: block;
		margin: 10px auto 0;
		cursor: pointer;
	}
	#app .el-icon-location {
		padding-left: 20px;
	}

	#app .el-menu-item {
		text-indent: 48px;
	}
	
	#app .is-active .el-submenu__title {
		font-weight: 800;
	}

	.userlog {
		width: 25px;
		height: 25px;
		margin: 17.5px 40px;
		margin-right: 0;
		background: url(../assets/img/houtai_logo.svg) center center no-repeat;
		background-size: 100% 100%;
	}

	#app .el-submenu__title:hover i,
	#app .el-submenu__title:hover span,
	#app .el-menu-item:focus i,
	#app .el-menu-item:hover i {
		color: #33B3FF;
	}
	.el-menu-item:hover{
		// background: rgba(51,179,255,1);
		// opacity:0.5;
	    color: #33B3FF;
	}
	// .el-menu-item:hover span{
	// 	color: #33B3FF;
	// 	opacity: 1;
	// }
	.el-submenu__title span{
		right: 45px;
        position: absolute;
		overflow: visible !important;
		visibility: visible !important;
		top: 20px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(187,187,187,1);
	}
	.el-submenu__title{
		height: 65px !important;
		line-height: 60px !important;
	}
	.is-active .el-submenu__title span{
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(51,179,255,1);
	}
	.is-active .el-submenu__title .iconfont{
		color: #33B3FF;
	}
	.el-submenu:hover,
	.is-opened:hover{
		background: #ffffff !important;
	}
	// .el-menu .is-active{
	// 	border-left: 2px solid #33B3FF;
	// }
	.el-menu--vertical .is-active{
		border-left: none;
	}
	
	
</style>
